/**
 * Disabled delete button with info dialog
 *
 * Original <DeleteButton> does not have option to be disabled, also in many
 * cases it is essential to display information dialog why this button
 * is disabled in UI. It is possible to pass any content <DeleteButtonDisabledWithDialog>,
 * this content will be show in the dialog
 *
 * Docs:
 * https://reactjs.org/docs/refs-and-the-dom.html
 *
 * @example
 *    import Typography from '@material-ui/core/Typography';
 *    import DeleteButtonDisabledWithDialog from '../../components/DeleteButtonDisabledWithDialog';
 *
 *    export const SampleParentComponent = () => (
 *      <DeleteButtonDisabledWithDialog>
 *        <Typography variant="subtitle1">You cannot delete this resource while related data exists.</Typography>
 *      </DeleteButtonDisabledWithDialog>
 *    );
 */

import React from 'react';
import DialogInfo from './DialogInfo';

import { DeleteButton } from 'react-admin';

const deleteButtonComponentStyles = `
  .coi-button__inactive {
    pointer-events: none;
    opacity: 0.5;
  }
`;

class DeleteButtonDisabledWithDialog extends React.Component {

  handleDialogOpen = event => {
    this.dialog.handleDialogOpen();
  };

  render() {
    return (
      <div>
        <div onClick={this.handleDialogOpen}>
          <style>{deleteButtonComponentStyles}</style>
          <DeleteButton className="coi-button__inactive" resource=""/>
        </div>
        <DialogInfo onRef={ref => (this.dialog = ref)}>
          {this.props.children}
        </DialogInfo>
      </div>
    );
  }
}

export default DeleteButtonDisabledWithDialog;
